import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import { NameProvider } from "@gp/utility";

export function formatTip(tip: BettingTips): string {
	const nameProvider = new NameProvider();
	const offerSpecifier = getOfferSpecifier(tip);

	const bettingTypeTip = nameProvider.getName(
		tip.bettingTypeTip,
		offerSpecifier
	);
	return bettingTypeTip;
}

export function formatType(tip: BettingTips): string {
	const nameProvider = new NameProvider();
	const offerSpecifier = getOfferSpecifier(tip);
	const bettingType = nameProvider.getName(
		tip.sportData.bettingTypeNameForBettingSlip,
		offerSpecifier
	);
	return bettingType;
}

export function getOfferSpecifier(tip: BettingTips) {
	return {
		competitor1: tip.sportData.teamOneName,
		competitor2: tip.sportData.teamTwoName,
		...tip.specifier,
	};
}
